import React from 'react';

// Simple, on-brand line-art face illustrations — one per face shape, so a
// customer can recognize "that's me" at a glance instead of having to
// interpret the word "Diamond". Deliberately abstract/line-art (hair
// silhouette + face outline + minimal features) rather than a stock photo
// or a specific skin tone/gender, so it reads as a shape guide for anyone,
// not a photo of one particular person. `active` swaps to a light-on-dark
// palette so the icon stays legible on the selected (filled) button state.
const PRIMARY = 'var(--sf-primary)';

const HAIR = {
  oval: 'M22,55 Q22,18 50,18 Q78,18 78,55 Q78,38 50,38 Q22,38 22,55 Z',
  round: 'M14,60 Q14,20 50,20 Q86,20 86,60 Q86,40 50,40 Q14,40 14,60 Z',
  square: 'M18,46 Q18,22 50,22 Q82,22 82,46 L82,34 Q82,26 50,26 Q18,26 18,34 Z',
  heart: 'M14,48 Q14,20 50,20 Q86,20 86,48 Q86,34 50,34 Q14,34 14,48 Z',
  diamond: 'M38,30 Q50,16 62,30 Q66,36 62,42 Q50,32 38,42 Q34,36 38,30 Z',
  oblong: 'M26,40 Q26,16 50,16 Q74,16 74,40 L74,28 Q74,20 50,20 Q26,20 26,28 Z',
};

const FACE = {
  oval: { tag: 'ellipse', props: { cx: 50, cy: 70, rx: 28, ry: 40 } },
  round: { tag: 'circle', props: { cx: 50, cy: 68, r: 38 } },
  square: { tag: 'rect', props: { x: 16, y: 28, width: 68, height: 80, rx: 18 } },
  heart: { tag: 'path', props: { d: 'M50,22 C74,22 90,40 90,60 C90,86 68,104 50,118 C32,104 10,86 10,60 C10,40 26,22 50,22 Z' } },
  diamond: { tag: 'path', props: { d: 'M50,16 C64,30 78,46 82,62 C78,82 64,100 50,118 C36,100 22,82 18,62 C22,46 36,30 50,16 Z' } },
  oblong: { tag: 'rect', props: { x: 24, y: 14, width: 52, height: 104, rx: 26 } },
};

const EYES = {
  oval: 62, round: 62, square: 66, heart: 58, diamond: 58, oblong: 56,
};

const SMILE = {
  oval: 'M40,88 Q50,94 60,88', round: 'M40,86 Q50,92 60,86', square: 'M40,96 Q50,102 60,96',
  heart: 'M40,92 Q50,98 60,92', diamond: 'M40,96 Q50,102 60,96', oblong: 'M40,94 Q50,100 60,94',
};

export function FaceShapeIcon({ shape, size = 44, active = false }) {
  const faceColor = active ? 'rgba(255,255,255,0.16)' : 'color-mix(in srgb, var(--sf-accent) 18%, #fff)';
  const lineColor = active ? '#fff' : PRIMARY;
  const FaceTag = FACE[shape]?.tag || 'ellipse';
  const faceProps = FACE[shape]?.props || FACE.oval.props;

  return (
    <svg width={size} height={size * 1.3} viewBox="0 0 100 130" fill="none" xmlns="http://www.w3.org/2000/svg">
      <FaceTag {...faceProps} fill={faceColor} stroke={lineColor} strokeWidth="3" />
      <path d={HAIR[shape] || HAIR.oval} fill={lineColor} />
      <circle cx="38" cy={EYES[shape] || 62} r="3.2" fill={lineColor} />
      <circle cx="62" cy={EYES[shape] || 62} r="3.2" fill={lineColor} />
      <path d={SMILE[shape] || SMILE.oval} stroke={lineColor} strokeWidth="3" strokeLinecap="round" fill="none" />
    </svg>
  );
}

export default FaceShapeIcon;
